import { Injectable } from "@angular/core";
import { Utils } from "../resources/utils";
import { State } from "../interfaces/state";
import { User } from "../interfaces/user";
import { Roles } from "../enums/roles.enum";
import { FIELDS_STATE, FIELDS_SECURITY_STUDY } from '../config/user.config';
import { AuthService } from "../services/authentication.service";
import { UserState } from "../enums/user-state.enum";
import { environment } from "src/environments/environment";

@Injectable()
export class UserManager {

  private holderId: string;

  constructor(
    private authService: AuthService,
    private utils: Utils
  ) {
    this.holderId = this.authService && this.authService.getCompany() ? this.authService.getCompany().companyId : null;
  }

  public sanitizeUser(originalUser: User, role: Roles.DRIVER | Roles.ADMIN | Roles.OWNER) {
    if (this.utils.objIsEmpty(originalUser))
      return null;
    const user = { ...originalUser };
    if (user &&
      user.state &&
      (!!user.state.active ||
        (!user.state.active &&
          user.state.description &&
          user.state.description != UserState.INACTIVE &&
          user.state.description != UserState.DOES_NOT_MEET_REQUIREMENTS))) return user;
    const fieldsState = FIELDS_STATE ? FIELDS_STATE[role] : [];
    const fieldsSecurityStudy = FIELDS_SECURITY_STUDY ? FIELDS_SECURITY_STUDY[role] : [];

    if (fieldsState && fieldsState.length) {
      fieldsState.forEach((field) => {
        try {
          if (!user[field] || !user[field].active) {
            if (!user[field]) user[field] = {};
            user[field]['active'] = false;
            user[field]['description'] = UserState.DOES_NOT_MEET_REQUIREMENTS;
            user.state.active = false;
            user.state.description = UserState.DOES_NOT_MEET_REQUIREMENTS;
            return;
          }
        } catch (e) { }
      });
    }

    if (fieldsSecurityStudy && fieldsSecurityStudy.length) {
      fieldsSecurityStudy.forEach((field) => {
        try {
          if (user[field].scoreTruora < 0.7) {
            user.state.active = false;
            user.state.description = UserState.LOW_SCORE;
            return;
          }
        } catch (e) { }
      });
    }
    return user;
  }

  hasValidPolicies(user: User): boolean {
    return user && user.lastUserTerm && user.lastUserTerm.state &&
      user && user.lastPrivacyPolicies && user.lastPrivacyPolicies.state &&
      user && user.lastPersonalDataPolicy && user.lastPersonalDataPolicy.state &&
      ((user && user.factoringContractLoggiFintech && user.factoringContractLoggiFintech.state && this.isTeclogiUser) || !this.isTeclogiUser) &&
      ((user && user.manifestBindingContract && user.manifestBindingContract.state && this.isTeclogiUser) || !this.isTeclogiUser) &&
      ((user && user.manifestBindingContractLogistics && user.manifestBindingContractLogistics.state && this.isTeclogiUser) || !this.isTeclogiUser) &&
      ((user && user.personalDataPolicyLogistics && user.personalDataPolicyLogistics.state && this.isTeclogiUser) || !this.isTeclogiUser)
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }
}
